import React from 'react'
import { CheckboxField as CheckboxFieldMedkit } from '@babylon/medkit'
import { PrivacyNotice } from '@babylon/consumer-api/types'
import { Checkbox } from '@babylon/web-platform-ui'
import NoticeLabel from '../NoticeLabel'
import withField from '../Forms/withField'

interface Props {
  name: string
  notice: PrivacyNotice
  validateMessage: string
  useDnaV2Design: Boolean
}

const CheckboxField = withField(Checkbox)

const NoticeCheckbox = ({
  name,
  notice,
  validateMessage,
  useDnaV2Design = false,
}: Props) => {
  const { noticeVersionId, mandatory } = notice

  if (useDnaV2Design) {
    return (
      <CheckboxField
        label={<NoticeLabel notice={notice} useDnaV2Design={useDnaV2Design} />}
        value={noticeVersionId}
        required={Boolean(mandatory)}
        data-testid={`noticeCheckbox-${noticeVersionId}`}
        validateMessage={validateMessage}
        key={noticeVersionId}
        name={name}
      />
    )
  }

  return (
    <CheckboxFieldMedkit
      data-testid={`noticeCheckbox-${noticeVersionId}`}
      testHandle={`noticeCheckbox-label-${noticeVersionId}`}
      key={noticeVersionId}
      name={name}
      value={noticeVersionId}
      validateMessage={validateMessage}
      required={Boolean(mandatory)}
    >
      <NoticeLabel notice={notice} useDnaV2Design={false} />
    </CheckboxFieldMedkit>
  )
}

export default NoticeCheckbox
